$(document).ready(function(){
    'use strict'
    $('#webTicker').show();

    // $('.simple-marquee-container').SimpleMarquee();
    $('#webTicker').webTicker({
        speed: 50,
        startEmpty: false,
        duplicate: false
    });
});
